import { cn } from "@/shared/lib/utils/cn";
import { Skeleton } from "@/shared/ui/shadcn-components/skeleton";

type CardSkeletonVariant = "agent" | "connection";

interface CardSkeletonProps {
  variant?: CardSkeletonVariant;
  className?: string;
}

/** Empty card placeholder with pulse highlight — matches Agent / Connection card chrome. */
export function CardSkeleton({ variant = "agent", className }: CardSkeletonProps) {
  if (variant === "connection") {
    return (
      <div
        role="status"
        aria-label="Loading"
        className={cn(
          "overflow-hidden rounded-2xl border border-border/60 bg-card p-4 shadow-sm",
          className,
        )}
      >
        <div className="flex items-start gap-3">
          <Skeleton className="size-10 shrink-0 rounded-xl" />
          <div className="min-w-0 flex-1 space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-3.5 w-28" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-4/5" />
            <Skeleton className="h-2.5 w-2/5" />
          </div>
          <Skeleton className="h-8 w-20 shrink-0 rounded-md" />
        </div>
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(
        "flex flex-col rounded-xl border border-border/60 bg-card shadow-sm",
        className,
      )}
    >
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div className="flex items-start justify-between">
          <Skeleton className="size-9 rounded-lg" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-3.5 w-2/3" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
        </div>
        <div className="space-y-2 border-t border-border/40 pt-3">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-5/6" />
          <Skeleton className="h-3 w-2/3" />
        </div>
      </div>
      <div className="px-4 pb-4">
        <Skeleton className="h-8 w-full rounded-lg" />
      </div>
    </div>
  );
}
